import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SlotIcon } from "../../../images/slotimage/slotimage.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewSlot from "./ViewSlot";


function Slot() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<SlotIcon />,
      mainheading: "Slot",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext:"Create New Slot",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addslot",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewSlot/>
    </div>
  );
}
export default Slot;